"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductSpecsMultiColumnContainerItemImage;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
const ImageWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageWrapper",
  class: "pl-i17n6n04"
});
const Image = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "Image",
  class: "pl-iha0ox2"
});
function ProductSpecsMultiColumnContainerItemImage({
  url,
  altText
}) {
  return /*#__PURE__*/_react.default.createElement(ImageWrapper, {
    "data-cy": "multi-column-image"
  }, /*#__PURE__*/_react.default.createElement(Image, {
    src: url,
    alt: altText
  }));
}
ProductSpecsMultiColumnContainerItemImage.propTypes = {
  url: _propTypes.default.string,
  altText: _propTypes.default.string
};